<template>
  <div class="chat">
    <!-- {{formParamSRSt}} -->
    <!-- {{linkRows}} -->
    <div class="chat-box">
      <div class="chats">
        <div class="chat chat-right">
          <div class="chat-body">
            <div class="chat-bubble">
              <div class="chat-content" style=" overflow-wrap: break-word;">
                <div class="chat-img-group clearfix"
                  v-if="formParamQRSt.header.message_type == 'image' && formParamQRSt.header.button_type != 'list_text'">
                  <a class="chat-img-attach" href="javascript:void(0)">
                    <img style="max-height:200px;" alt :src="formParamQRSt.header.image_url" />
                  </a>
                </div>
                <ul class="attach-list"
                  v-if="formParamQRSt.header.message_type == 'document' && formParamQRSt.header.button_type != 'list_text'">
                  <li>
                    <i class="fa fa-file"></i>
                    <a :href="formParamQRSt.header.image_url" target="_blank">File</a>
                  </li>
                </ul>
                <p v-html="messageFilter(formParamQRSt.header.message)" v-if="formParamQRSt.header.message != ''"
                  v-linkified></p>

              </div>

              <div class="chat-content" style=" overflow-wrap: break-word;"
                v-if="(formParamQRSt.header.message_type == 'image' || formParamQRSt.header.message_type == 'document') && formParamQRSt.header.button_type == 'list_text'">
                <div class="chat-img-group clearfix"
                  v-if="formParamQRSt.header.message_type == 'image' && formParamQRSt.header.button_type == 'list_text'">
                  <a class="chat-img-attach" href="javascript:void(0)">
                    <img style="max-height:200px;" alt :src="formParamQRSt.header.image_url" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr v-if="formParamQRSt.header.is_enable_away_message_status == true" />
      <div class="chats" v-if="formParamQRSt.header.is_enable_away_message_status == true">
        <div class="chat chat-right">
          <div class="chat-body">
            <div class="chat-bubble">
              <div class="chat-content">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    buttonsRows: {
      type: Array,
      default: () => [{ button_text: "" }]
    },
    linkRows: {
      type: Array
    }
  },
  data() {
    return {
      isLoading: false
    };
  },
  watch: {},
  computed: {
    formParamQRSt() {
      return this.$store.state.automation.formParamQRSt;
    }
  },
  methods: {
    getButtonLabelById(id) {
      let arr = this.buttonsRows.find(msgs => msgs.id === id);
      if (arr != null && typeof arr.button_text != "undefined") {
        return arr.button_text;
      } else {
        return "";
      }
    },
    getLinkLabelById(id) {
      let arr = this.linkRows.find(msgs => msgs.id === id);
      if (arr != null && typeof arr.button_text != "undefined") {
        if (arr.button_type == "call") {
          return '<i class="fa fa-phone"></i> ' + arr.button_text;
        } else {
          return '<i class="fa fa-external-link"></i> ' + arr.button_text;
        }
      } else {
        return "";
      }
    },
    messageFilter(message) {
      return message.replace(/\r?\n/g, "<br />");
    }
  },
  async created() { },
  beforeDestroy() { },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add"
};
</script>


// WEBPACK FOOTER //
// src/views/automation/textReply/preview.vue